import React, { useEffect, useState } from 'react';
import keycloak from '../keycloak';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { useKeycloak } from '@react-keycloak/web';
import JustrediLoader from '../components/justrediLoader';
import { Card, CardFooter, CardHeader, CardTitle, CardDescription } from '../shadcnComponents/ui/card';
import { Button } from '../shadcnComponents/ui/button';
import { PRODUCTION } from '../global';

function Login() {
  const navigate = useNavigate;
  const reactKeycloak = useKeycloak()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (keycloak.authenticated) {
      navigate('/home')
    }
  }, [])

  useEffect(() => {
    setLoading(!reactKeycloak.initialized)
  }, [reactKeycloak])

  const handleLogin = () => {
    keycloak.login().then(r => {
      async function getInfo() {
        const info = await keycloak.loadUserInfo().then(info => info, error => {
          console.error('Got an error on getInfo', error)
          setLoading(false);
          keycloak.logout({ redirectUri: PRODUCTION ? "https://apps.ilsp.gr/justredi/login" : 'https://chomsky.ilsp.gr:3003/justredi/login' })
            .then(() => {
              console.error('Got an error on getInfo')
              localStorage.removeItem('justredi_token')
              localStorage.removeItem('justredi_idToken')
              localStorage.removeItem('user')
            });
        });
        if (info && info.resource_access && setUserInfo) {
          localStorage.setItem('user', JSON.stringify(info))
          setLoading(false)
        }
      }
      if (keycloak.authenticated) {
        getInfo();
      }
      console.log('r', r)
    }, e => { console.log('e', e) });
  };

  if (loading) {
    return (<JustrediLoader />)
  } else {
    return (
      <Layout authenticated={false}>
        <div className="h-full w-screen flex items-center justify-center bg-background">
          <Card className="w-full max-w-sm">
            <CardHeader>
              <CardTitle>Justredi Transcript Editor</CardTitle>
              <CardDescription>
                Συνδεθείτε για να συνεχίσετε
              </CardDescription>
            </CardHeader>
            <CardFooter className="flex-col gap-2">
              <Button type="submit" className="w-full" onClick={handleLogin}>
                Σύνδεση
              </Button>
            </CardFooter>
          </Card>
        </div>
      </Layout>
    );
  }
}

export default Login;
